import { module } from 'angular';
import App from '../../../app';

class SCR1202Controller {
	
	constructor ($scope, $state, $timeout, $uibModalInstance, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		this.initWindow(960, 640);
		this.initText();
		this.initSearch();
		this.initSelect();
		
		this.$timeout(() => {
			this.setGridHeight();
			this.initDeploySysGridOption();
			this.getDeploySysList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			modalHeader : bxMsg('manageDeploySystem.modalHeader'),
			deploySysCd : bxMsg('manageDeploySystem.deploySysCd'),
			deploySysNm : bxMsg('manageDeploySystem.deploySysNm'),
			deploySysGrpCd : bxMsg('manageDeploySystem.deploySysGrpCd'),
			deploySysDesc : bxMsg('manageDeploySystem.deploySysDesc'),
			deploySysUrl: bxMsg('manageDeploySystem.deploySysUrl'),
			select : bxMsg('common.select'),
			cancel : bxMsg('common.cancel'),
			search : bxMsg('common.search'),
			resetSearch : bxMsg('common.resetSearch')
		};
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initDeploySysGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
    		 {fieldName: "deploySysCd"}, {fieldName: "deploySysNm"}, {fieldName: "deploySysUrl"}, {fieldName: "deploySysDesc"}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "deploySysCd", fieldName: "deploySysCd", header : { text: this.text.deploySysCd }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "deploySysNm", fieldName: "deploySysNm", header : { text: this.text.deploySysNm }, width: 100, styles: { textWrap: 'ellipse' } },
			{ name: "deploySysUrl", fieldName: "deploySysUrl", header : { text: this.text.deploySysUrl }, width: 200, styles: { textWrap: 'ellipse' } },
			{ name: "deploySysDesc", fieldName: "deploySysDesc", header : { text: this.text.deploySysDesc }, width: 200, styles: { textWrap: 'ellipse' } }
		]);
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true)
		};
	}
	
	getDeploySysList(goToFirst = false) {
		const { pageNumber, pageSize } = this.getPageInfo();
		let url = `/depolysyss?pageNumber=${ goToFirst ? 1 : pageNumber}&pageSize=${pageSize}`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			if(goToFirst) {
				this.pageNumber = 1;
				this.$scope.$broadcast(`resetPage`, this.pageNumber);
			}
			
			this.recordsCount = data.totalCnt;
			this.dataProvider.setRows(data.depolysysbsOutList);
		});
	}
	
	getPageInfo() {
		return {
			pageNumber: this.pageNumber || 1,
			pageSize: this.select.pageSize
		};
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getDeploySysList(true);
	}
	
	search(){
		this.getDeploySysList(true);
	}
	
	blur($event){
		$event.target.blur();
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.getDeploySysList(num === 1);
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getSelectedRows();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.$uibModalInstance.close(this.gridView.getValues(selection[0]));
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	setGridHeight() {
		let $msgGrid = $('#grid');
		let height = this.gridService.getGridHeight(this.select.pageSize);
		
		$msgGrid.height(height);
	}
}

module(App.name).controller('SCR1202Controller', SCR1202Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1202/SCR1202.controller.js